import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { PineParseStatus } from "../../types/reportStrategyPine";
import {
  getParseStatusDisplay,
  parseStatusAlertStatus,
  type PineUxCopy,
} from "../../utils/pineIrUi";
import { STRATEGY_PINE_SECTION_DESC_CLASS, STRATEGY_PINE_SECTION_LABEL_CLASS } from "./StrategyPineSectionCard";
import {
  STRATEGY_PINE_ALERT_CLASS,
  StrategyPineAlertIcon,
  strategyPineAlertVariant,
} from "./strategyPineAlertUi";

export type StrategyPineParseStatusBannerProps = {
  status?: PineParseStatus | string | null;
  parseStatusUx?: Record<string, PineUxCopy> | null;
  textColor?: string;
};

export function StrategyPineParseStatusBanner({
  status,
  parseStatusUx,
}: StrategyPineParseStatusBannerProps): React.ReactElement | null {
  const ux = getParseStatusDisplay(status, parseStatusUx);
  if (!status || !ux) return null;

  const showDescription = status !== "full" && ux.description.trim().length > 0;
  const tone = parseStatusAlertStatus(status);

  return (
    <Alert variant={strategyPineAlertVariant(tone)} className={STRATEGY_PINE_ALERT_CLASS}>
      <StrategyPineAlertIcon tone={tone} />
      <AlertTitle className={STRATEGY_PINE_SECTION_LABEL_CLASS}>{ux.title}</AlertTitle>
      {showDescription ? (
        <AlertDescription className={STRATEGY_PINE_SECTION_DESC_CLASS}>
          {ux.description}
        </AlertDescription>
      ) : null}
    </Alert>
  );
}
